import { render } from "./PagoServicio.vue?vue&type=template&id=54b19286&scoped=true"
import script from "./PagoServicio.vue?vue&type=script&lang=js"
export * from "./PagoServicio.vue?vue&type=script&lang=js"

import "./PagoServicio.vue?vue&type=style&index=0&id=54b19286&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b19286"]])

export default __exports__